export interface Actress {
  id: string;
  name: string;
  nameJa: string;
  avatar: string;
  overallScore: number;
  popularityScore: number;
  boxOfficeScore: number;
  actingScore: number;
  fansCount: number;
  rank: number;
  debutYear: number;
  agency: string;
  tags: string[];
  category: string[];
  trend: 'up' | 'down' | 'stable';
}

export const actresses: Actress[] = [
  {
    id: 'actress-001',
    name: '樱井美月',
    nameJa: '櫻井美月',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20elegant%20long%20black%20hair%2C%20soft%20natural%20makeup%2C%20wearing%20simple%20white%20blouse%2C%20warm%20studio%20lighting%2C%20gentle%20expression%2C%20clean%20minimal%20background%2C%20professional%20portrait%20photography%2C%20soft%20bokeh%2C%20asian%20beauty%20editorial%20style&width=400&height=500&seq=actress-001&orientation=portrait',
    overallScore: 9.7,
    popularityScore: 9.8,
    boxOfficeScore: 9.6,
    actingScore: 9.5,
    fansCount: 2850000,
    rank: 1,
    debutYear: 2019,
    agency: 'S1 NO.1 STYLE',
    tags: ['演技派', '票房女王', '人气TOP'],
    category: ['comprehensive', 'popularity', 'boxoffice', 'acting'],
    trend: 'stable',
  },
  {
    id: 'actress-002',
    name: '高桥玲奈',
    nameJa: '高橋玲奈',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20shoulder%20length%20brown%20hair%2C%20bright%20smile%2C%20wearing%20cream%20colored%20knit%20top%2C%20soft%20natural%20daylight%2C%20friendly%20warm%20expression%2C%20clean%20neutral%20background%2C%20polished%20portrait%20photography%2C%20asian%20model%20editorial&width=400&height=500&seq=actress-002&orientation=portrait',
    overallScore: 9.5,
    popularityScore: 9.7,
    boxOfficeScore: 9.3,
    actingScore: 9.4,
    fansCount: 2520000,
    rank: 2,
    debutYear: 2020,
    agency: 'MOODYZ',
    tags: ['治愈系', '人气飙升', '全能型'],
    category: ['comprehensive', 'popularity', 'acting'],
    trend: 'up',
  },
  {
    id: 'actress-003',
    name: '松岛枫香',
    nameJa: '松島楓香',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20sleek%20ponytail%2C%20confident%20expression%2C%20wearing%20black%20turtleneck%2C%20dramatic%20studio%20lighting%2C%20strong%20eye%20contact%2C%20minimal%20dark%20background%2C%20editorial%20fashion%20portrait%2C%20asian%20professional%20model%2C%20bold%20yet%20elegant&width=400&height=500&seq=actress-003&orientation=portrait',
    overallScore: 9.4,
    popularityScore: 9.2,
    boxOfficeScore: 9.8,
    actingScore: 9.3,
    fansCount: 2180000,
    rank: 3,
    debutYear: 2018,
    agency: 'PRESTIGE',
    tags: ['票房冠军', '御姐系', '实力派'],
    category: ['comprehensive', 'boxoffice'],
    trend: 'up',
  },
  {
    id: 'actress-004',
    name: '伊藤真由',
    nameJa: '伊藤真由',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20cute%20short%20bob%20haircut%2C%20youthful%20fresh%20look%2C%20wearing%20pastel%20pink%20sweater%2C%20soft%20dreamy%20lighting%2C%20innocent%20expression%2C%20clean%20white%20background%2C%20kawaii%20style%20portrait%2C%20asian%20young%20woman%2C%20bright%20and%20airy%20mood&width=400&height=500&seq=actress-004&orientation=portrait',
    overallScore: 9.2,
    popularityScore: 9.5,
    boxOfficeScore: 8.9,
    actingScore: 9.6,
    fansCount: 1950000,
    rank: 4,
    debutYear: 2021,
    agency: 'SOD Create',
    tags: ['演技天才', '清新系', '新人王'],
    category: ['comprehensive', 'popularity', 'acting'],
    trend: 'up',
  },
  {
    id: 'actress-005',
    name: '渡边优香',
    nameJa: '渡辺優香',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20wavy%20long%20auburn%20hair%2C%20mature%20elegant%20look%2C%20wearing%20burgundy%20silk%20blouse%2C%20warm%20ambient%20lighting%2C%20sophisticated%20expression%2C%20luxurious%20minimal%20background%2C%20high%20end%20portrait%20photography%2C%20asian%20beauty%2C%20refined%20and%20graceful&width=400&height=500&seq=actress-005&orientation=portrait',
    overallScore: 9.1,
    popularityScore: 9.0,
    boxOfficeScore: 9.5,
    actingScore: 9.2,
    fansCount: 1780000,
    rank: 5,
    debutYear: 2017,
    agency: 'IDEAPOCKET',
    tags: ['常青树', '票房保障', '优雅系'],
    category: ['comprehensive', 'boxoffice', 'acting'],
    trend: 'stable',
  },
  {
    id: 'actress-006',
    name: '山田心美',
    nameJa: '山田心美',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20medium%20black%20hair%2C%20gentle%20shy%20smile%2C%20wearing%20light%20blue%20cardigan%2C%20soft%20window%20light%2C%20natural%20looking%20portrait%2C%20simple%20beige%20background%2C%20girl%20next%20door%20vibe%2C%20asian%20natural%20beauty%2C%20warm%20and%20approachable&width=400&height=500&seq=actress-006&orientation=portrait',
    overallScore: 8.9,
    popularityScore: 9.3,
    boxOfficeScore: 8.5,
    actingScore: 8.8,
    fansCount: 1620000,
    rank: 6,
    debutYear: 2022,
    agency: 'FALENO',
    tags: ['新人黑马', '甜美系', '人气急升'],
    category: ['comprehensive', 'popularity', 'newcomer'],
    trend: 'up',
  },
  {
    id: 'actress-007',
    name: '中村明日香',
    nameJa: '中村明日香',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20sleek%20straight%20dark%20hair%2C%20intense%20gaze%2C%20wearing%20white%20silk%20camisole%2C%20contrasty%20dramatic%20lighting%2C%20serious%20expression%2C%20dark%20moody%20background%2C%20cinematic%20portrait%20style%2C%20asian%20actress%2C%20powerful%20presence&width=400&height=500&seq=actress-007&orientation=portrait',
    overallScore: 8.8,
    popularityScore: 8.6,
    boxOfficeScore: 9.1,
    actingScore: 9.0,
    fansCount: 1450000,
    rank: 7,
    debutYear: 2020,
    agency: 'ATTACKERS',
    tags: ['演技派', '剧情女王', '实力派'],
    category: ['comprehensive', 'boxoffice', 'acting'],
    trend: 'stable',
  },
  {
    id: 'actress-008',
    name: '桥本爱莉',
    nameJa: '橋本愛莉',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20cute%20twin%20tails%20hairstyle%2C%20playful%20happy%20expression%2C%20wearing%20colorful%20casual%20hoodie%2C%20bright%20fun%20lighting%2C%20energetic%20vibe%2C%20clean%20colorful%20studio%20background%2C%20young%20and%20trendy%20portrait%2C%20asian%20pop%20style%2C%20vibrant%20and%20lively&width=400&height=500&seq=actress-008&orientation=portrait',
    overallScore: 8.7,
    popularityScore: 9.1,
    boxOfficeScore: 8.3,
    actingScore: 8.5,
    fansCount: 1380000,
    rank: 8,
    debutYear: 2023,
    agency: 'kawaii',
    tags: ['新生代', '偶像系', '社交达人'],
    category: ['comprehensive', 'popularity', 'newcomer'],
    trend: 'up',
  },
  {
    id: 'actress-009',
    name: '田中理惠',
    nameJa: '田中理恵',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20elegant%20updo%20hairstyle%2C%20calm%20composed%20expression%2C%20wearing%20dark%20green%20velvet%20dress%2C%20classic%20portrait%20lighting%2C%20refined%20graceful%20look%2C%20sophisticated%20dark%20background%2C%20timeless%20portrait%20photography%2C%20asian%20mature%20beauty%2C%20dignified%20presence&width=400&height=500&seq=actress-009&orientation=portrait',
    overallScore: 8.6,
    popularityScore: 8.4,
    boxOfficeScore: 8.8,
    actingScore: 8.9,
    fansCount: 1250000,
    rank: 9,
    debutYear: 2016,
    agency: 'Madonna',
    tags: ['资深演员', '熟女系', '经典'],
    category: ['comprehensive', 'acting', 'boxoffice'],
    trend: 'stable',
  },
  {
    id: 'actress-010',
    name: '小林七海',
    nameJa: '小林七海',
    avatar: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20with%20long%20silky%20dark%20hair%2C%20mysterious%20alluring%20gaze%2C%20wearing%20red%20off%20shoulder%20top%2C%20warm%20candlelight%20style%20lighting%2C%20sultry%20expression%2C%20romantic%20dark%20background%2C%20glamour%20portrait%2C%20asian%20seductive%20beauty%2C%20atmospheric%20mood&width=400&height=500&seq=actress-010&orientation=portrait',
    overallScore: 8.5,
    popularityScore: 8.9,
    boxOfficeScore: 8.2,
    actingScore: 8.3,
    fansCount: 1180000,
    rank: 10,
    debutYear: 2022,
    agency: 'WANZ FACTORY',
    tags: ['人气新星', '性感系', '话题女王'],
    category: ['comprehensive', 'popularity', 'newcomer'],
    trend: 'up',
  },
];

export const getActressesByCategory = (category: string): Actress[] => {
  return actresses.filter(a => a.category.includes(category));
};